import { atom, useAtom } from 'jotai';
import { getTokenFromURL } from 'utils/get-token-from-url';

const isEditMode = atom<boolean>(!!getTokenFromURL());

export const useIsEditMode = () => useAtom(isEditMode);
